/** Default (unrestricted) access for a category or metric. */
export const ORGANIZATION_ACCESS = 'organization'
export const RESTRICTED_ACCESS = 'restricted'

/** The access fields of a category or metric, as the settings forms edit them. */
export function accessAudienceOf(resource) {
  return {
    access: resource?.access === RESTRICTED_ACCESS ? RESTRICTED_ACCESS : ORGANIZATION_ACCESS,
    allowed_roles: [...(resource?.allowed_roles || [])],
    allowed_user_ids: [...(resource?.allowed_user_ids || [])],
    audience_members: resource?.audience_members || [],
  }
}

/** The PATCH body for access - always all three fields together, so the audience is replaced as a unit. */
export function accessAudiencePayload(value) {
  const restricted = value?.access === RESTRICTED_ACCESS
  return {
    access: restricted ? RESTRICTED_ACCESS : ORGANIZATION_ACCESS,
    allowed_roles: restricted ? [...(value.allowed_roles || [])].sort() : [],
    allowed_user_ids: restricted ? [...(value.allowed_user_ids || [])].sort() : [],
  }
}

/** Whether the edited access differs from what was loaded. */
export function accessAudienceChanged(initial, current) {
  return JSON.stringify(accessAudiencePayload(initial)) !== JSON.stringify(accessAudiencePayload(current))
}
